export default __webpack_public_path__ + "static/media/100tb.a842192c.svg";